import { useEffect, useState } from 'react'

const useWebSocket = (url) => {
    const [messages, setMessages] = useState([])
    const [socket, setSocket] = useState(null)

    useEffect(() => {
        //  Only connect if url is valid 
        if (!url) {
            console.warn('WebSocket URL is undefined, skipping connection')
            return
        }

        const ws = new WebSocket(url)

        ws.onopen = () => {
            console.log('WebSocket Connected')
        }

        ws.onmessage = (event) => {
            const data = JSON.parse(event.data)
            console.log('Received WebSocket Message:', data)
            setMessages((prev) => [...prev, data])
        }

        ws.onerror = (error) => {
            console.error('WebSocket Error:', error)
        }

        ws.onclose = () => {
            console.log('WebSocket Disconnected')
        }

        setSocket(ws)

        return () => {
            ws.close()
        }
    }, [url])

    return { messages, socket }
}

export default useWebSocket
